import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, } from "react-router-dom";
import "./MobileSettings.css";
import { Table } from "react-bootstrap";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import edititem from "../../../components/Images/edititem.svg";
import deleteitem from "../../../components/Images/deleteitem.svg";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoMdInformationCircle } from "react-icons/io";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function MobileSettings(props) {
  const [data, setData] = useState([]);
  const [splash, setSplash] = useState([]);
  const [loading, setLoading] = useState(true);

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();
  const [editUser, setEditUser] = useState({
    name: "",
    description: ""
  });
  // const [formDataError, setFormDataError] = useState({ name: "" });

  const [formDataError, setFormDataError] = useState({});

  const validateName = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return "Name cannot be empty.";
    if (trimmed.length < 3) return "Name must be at least 3 characters.";
    if (trimmed.length > 100) return "Name must be less than 100 characters.";
    return "";
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trimStart();

    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: trimmedValue,
    }));

    if (name === "name") {
      if (!trimmedValue || trimmedValue.length < 3 || trimmedValue.length > 100) {
        setFormDataError((prev) => ({
          ...prev,
          name: "Name must be 3 to 100 characters.",
        }));
      } else {
        setFormDataError((prev) => ({
          ...prev,
          name: "",
        }));
      }
    }
  };



  // const handleInput = (e) => {
  //   const { name, value } = e.target;
  //   setEditUser((prevEditUser) => ({
  //     ...prevEditUser,
  //     [name]: value,
  //   }));

  //   setValidationMessagename("");
  //   setIsValidationHiddenname(true);
  // };

  const handleBlurName = (e) => {
    const { value } = e.target;
    const error = validateName(value);
    if (error) {
      setFormDataError((prev) => ({
        ...prev,
        name: error,
      }));
    }
  };



  const fetchData = async () => {
    try {
      const welcomeResponse = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/welcome-screen-index`,
        { headers: headers }
      );
      setData(welcomeResponse?.data?.Welcome_Screen);

      const splashResponse = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-index`,
        { headers: headers }
      );
      setSplash(splashResponse?.data?.splash_Screen);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const fileInputRef4 = useRef(null);
  const fileInputRef5 = useRef(null);
  const fileInputRef6 = useRef(null);
  const fileInputRef7 = useRef(null);
  const fileInputRef8 = useRef(null);
  const fileInputRef9 = useRef(null);
  const fileInputRef10 = useRef(null);
  const fileInputRef11 = useRef(null);
  const fileInputRef12 = useRef(null);
  const fileInputRef13 = useRef(null);
  const fileInputRef14 = useRef(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [selectedFile3, setSelectedFile3] = useState(null);
  const [selectedFile4, setSelectedFile4] = useState(null);
  const [selectedFile5, setSelectedFile5] = useState(null);
  const [selectedFile6, setSelectedFile6] = useState(null);
  const [selectedFile7, setSelectedFile7] = useState(null);
  const [selectedFile8, setSelectedFile8] = useState(null);
  const [selectedFile9, setSelectedFile9] = useState(null);
  const [selectedFile10, setSelectedFile10] = useState(null);
  const [selectedFile11, setSelectedFile11] = useState(null);
  const [selectedFile12, setSelectedFile12] = useState(null);
  const [selectedFile13, setSelectedFile13] = useState(null);
  const [selectedFile14, setSelectedFile14] = useState(null);

  const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];

  const handleFileChangesss = (event, fileInputRef, setSelectedFile, fieldKey) => {
    const file = event.target.files[0];
    if (file) {
      if (!allowedTypes.includes(file.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [fieldKey]: "Only JPG, JPEG, PNG, WEBP and GIF files are allowed.",
        }));
        return;
      }

      setSelectedFile(file);
      setFormDataError((prev) => ({
        ...prev,
        [fieldKey]: "",
      }));
    }
  };



  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      case 2:
        setSelectedFile2(null);
        if (fileInputRef2.current) {
          fileInputRef2.current.value = null;
        }
        break;
      case 3:
        setSelectedFile3(null);
        if (fileInputRef3.current) {
          fileInputRef3.current.value = null;
        }
        break;
      case 4:
        setSelectedFile4(null);
        if (fileInputRef4.current) {
          fileInputRef4.current.value = null;
        }
        break;
      case 5:
        setSelectedFile5(null);
        if (fileInputRef5.current) {
          fileInputRef5.current.value = null;
        }
        break;
      case 6:
        setSelectedFile6(null);
        if (fileInputRef6.current) {
          fileInputRef6.current.value = null;
        }
        break;
      case 7:
        setSelectedFile7(null);
        if (fileInputRef7.current) {
          fileInputRef7.current.value = null;
        }
        break;
      case 8:
        setSelectedFile8(null);
        if (fileInputRef8.current) {
          fileInputRef8.current.value = null;
        }
        break;
      case 9:
        setSelectedFile9(null);
        if (fileInputRef9.current) {
          fileInputRef9.current.value = null;
        }
        break;
      case 10:
        setSelectedFile10(null);
        if (fileInputRef10.current) {
          fileInputRef10.current.value = null;
        }
        break;
      case 11:
        setSelectedFile11(null);
        if (fileInputRef11.current) {
          fileInputRef11.current.value = null;
        }
        break;
      case 12:
        setSelectedFile12(null);
        if (fileInputRef12.current) {
          fileInputRef12.current.value = null;
        }
        break;
      case 13:
        setSelectedFile13(null);
        if (fileInputRef13.current) {
          fileInputRef13.current.value = null;
        }
        break;
      case 14:
        setSelectedFile14(null);
        if (fileInputRef14.current) {
          fileInputRef14.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  async function savesplash() {
    const formData = new FormData();

    formData.append("splash_image", selectedFile1);
    formData.append("andriod_splash_image", selectedFile2);
    formData.append("AndroidTv_splash_screen", selectedFile4);
    formData.append("LG_splash_screen", selectedFile5);
    formData.append("RokuTV_splash_screen", selectedFile6);
    formData.append("Samsung_splash_screen", selectedFile7);
    formData.append("Firetv_splash_screen", selectedFile8);

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    let firstApiStatus = false;
    let resultapi = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const updateResponse = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-store-update`,
        formData,
        { headers }
      );

      if (updateResponse.data.status === true) {
        const updatedId = updateResponse.data.splash_screen.id; // ✅ FIXED
        const modelName = "MobileAppSetting";

        const formDataAdd = new FormData();
        formDataAdd.append("id", updatedId);
        formDataAdd.append("modelName", modelName);
        formDataAdd.append('imageFields[]', 'splash_image');
        formDataAdd.append('imageFields[]', 'andriod_splash_image');
        formDataAdd.append('imageFields[]', 'AndroidTv_splash_screen');
        formDataAdd.append('imageFields[]', 'LG_splash_screen');
        formDataAdd.append('imageFields[]', 'RokuTV_splash_screen');
        formDataAdd.append('imageFields[]', 'Samsung_splash_screen');
        formDataAdd.append('imageFields[]', 'Firetv_splash_screen');

        formDataAdd.append("splash_image", selectedFile1);
        formDataAdd.append("andriod_splash_image", selectedFile2);
        formDataAdd.append("AndroidTv_splash_screen", selectedFile4);
        formDataAdd.append("LG_splash_screen", selectedFile5);
        formDataAdd.append("RokuTV_splash_screen", selectedFile6);
        formDataAdd.append("Samsung_splash_screen", selectedFile7);
        formDataAdd.append("Firetv_splash_screen", selectedFile8);

        await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formDataAdd,
        });

        await fetchData();
        handleModalOpenSplash();
        setProcessing(false);
        setShowOverlay(false);
      } else {
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  const [validationMessagename, setValidationMessagename] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);

  const nameInputRef = useRef(null);

  async function savewelcome() {
    let focusInputRef = null;
    const trimmedWelcomeName = editUser?.name?.trim();

    if (!trimmedWelcomeName) {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    } else if (trimmedWelcomeName.length < 3) {
      setValidationMessagename("Name must be at least 3 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    } else if (trimmedWelcomeName.length > 100) {
      setValidationMessagename("Name must not exceed 100 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    } else {
      setValidationMessagename("");
      setIsValidationHiddenname(true);
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    const formData = new FormData();
    formData.append("welcome_images", selectedFile3);
    formData.append("name", editUser?.name);
    formData.append("description", editUser?.description);
    formData.append("andriod_Welcome_Screen", selectedFile9);
    formData.append("AndroidTv_Welcome_Screen", selectedFile10);
    formData.append("LG_Welcome_Screen", selectedFile11);
    formData.append("RokuTV_Welcome_Screen", selectedFile12);
    formData.append("Samsung_Welcome_Screen", selectedFile13);
    formData.append("Firetv_Welcome_Screen", selectedFile14);
    formData.append("id", "");

    const headers = {
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const updateResponse = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/welcome-screen-store-update`,
        formData,
        { headers }
      );

      if (updateResponse.data.status === true) {
        const updatedId = updateResponse.data.welcome_screen.id;
        const modelName = "WelcomeScreen";
        const formDataAdd = new FormData();
        formDataAdd.append("id", updatedId);
        formDataAdd.append("modelName", modelName);
        formDataAdd.append("imageFields[]", "welcome_images");
        formDataAdd.append("imageFields[]", "andriod_Welcome_Screen");
        formDataAdd.append("imageFields[]", "AndroidTv_Welcome_Screen");
        formDataAdd.append("imageFields[]", "LG_Welcome_Screen");
        formDataAdd.append("imageFields[]", "RokuTV_Welcome_Screen");
        formDataAdd.append("imageFields[]", "Samsung_Welcome_Screen");
        formDataAdd.append("imageFields[]", "Firetv_Welcome_Screen");

        formDataAdd.append("welcome_images", selectedFile3);
        formDataAdd.append("andriod_Welcome_Screen", selectedFile9);
        formDataAdd.append("AndroidTv_Welcome_Screen", selectedFile10);
        formDataAdd.append("LG_Welcome_Screen", selectedFile11);
        formDataAdd.append("RokuTV_Welcome_Screen", selectedFile12);
        formDataAdd.append("Samsung_Welcome_Screen", selectedFile13);
        formDataAdd.append("Firetv_Welcome_Screen", selectedFile14);

        await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formDataAdd,
        });

        await fetchData();
        handleModalOpenWelcome();
        setProcessing(false);
        setShowOverlay(false);
      } else {
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  const splashdelete = (id) => {
    const access_token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    };
    axios
      .delete(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-delete/` +
        id,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          var responseData = response.data;
          props.setApiresponsealert(responseData);
          props.setShowalert(true);
          fetchData();
        } else {
          if (responseData === false) {
            var resultError = responseData;
            props.setApiresponsealert(resultError);
            props.setShowalert(true);
          }
        }
      });
  };

  const [itemToDeletesplash, setItemToDeletesplash] = useState(null);
  const [successMessagesplash, setSuccessMessagesplash] = useState("");

  const openModalsplash = (id) => {
    setItemToDeletesplash(id);
    setSuccessMessagesplash("");
  };

  const closeModalsplash = () => {
    setItemToDeletesplash(null);
  };
  const handleDeletedatasplash = () => {
    closeModalsplash();
    if (itemToDeletesplash) {
      splashdelete(itemToDeletesplash);
    }
  };

  const welcomedelete = (id) => {
    const access_token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    };
    axios
      .delete(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/welcome-screen-delete/` +
        id,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          var responseData = response.data;
          props.setApiresponsealert(responseData);
          props.setShowalert(true);
          fetchData();
        } else {
          if (responseData === false) {
            var resultError = responseData;
            props.setApiresponsealert(resultError);
            props.setShowalert(true);
          }
        }
      });
  };

  const [itemToDeletewelcome, setItemToDeletewelcome] = useState(null);
  const [successMessagewelcome, setSuccessMessagewelcome] = useState("");

  const openModalwelcome = (id) => {
    setItemToDeletewelcome(id);
    setSuccessMessagewelcome("");
  };

  const closeModalwelcome = () => {
    setItemToDeletewelcome(null);
  };
  const handleDeletedata = () => {
    closeModalwelcome();
    if (itemToDeletewelcome) {
      welcomedelete(itemToDeletewelcome);
    }
  };


  const getFileType = (url) => {
    const extension = url?.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'webp':
      case 'bmp':
      case 'svg':
        return 'image';
      case 'gif':
        return 'gif';
      case 'mp4':
        return 'video';
      case 'webm':
        return 'video';
      case 'ogg':
        return 'video';
      case 'm3u8':
        return 'video';
      default:
        return 'application';
    }
  };

  // Renders the correct element for any uploaded media URL.
  // GIFs use <img> so they animate naturally; videos use <video controls>.
  const renderMedia = (url) => {
    if (!url) return null;
    const fileType = getFileType(url);
    if (fileType === 'gif') {
      return (
        <img
          src={url}
          alt="Animated GIF"
          className="thumbnails-images-mobilesetting"
        />
      );
    }
    if (fileType === 'image') {
      return (
        <img
          src={url}
          alt="Media"
          className="thumbnails-images-mobilesetting"
        />
      );
    }
    if (fileType === 'video') {
      return (
        <video
          src={url}
          controls
          className="thumbnails-video-mobilesetting"
        />
      );
    }
    return null;
  };



  const [showModalSplash, setShowModalSplash] = useState(false);
  const [selectedSplashItem, setSelectedSplashItem] = useState(null);

  // Close modal
  const handleCloseSplash = () => setShowModalSplash(false);

  // Confirm toggle and send POST request
  const confirmToggleSplash = async () => {
    handleCloseSplash();
    console.log('Confirmed toggle for:', selectedSplashItem);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/splash-screen-active`,
        {
          id: selectedSplashItem?.id,
          active: selectedSplashItem?.active,
        },
        { headers: headers }
      );

      console.log('Toggle successful:', response.data);
      toast.success('Splash screen status updated successfully!');
      fetchData();
    } catch (error) {
      console.error('Error toggling item:', error);
      toast.error('Failed to update splash screen status.');
    }
  };

  // Handle toggle click
  const handleToggleSplash = (e, item) => {
    if (item.active === 0) {
      setSelectedSplashItem({
        ...item,
        active: 1, // activating
      });
      setShowModalSplash(true);
    } else {
      console.log('Item already active. No action triggered.');
    }
  };
  // Welcome
  const [showModalWelcome, setShowModalWelcome] = useState(false);
  const [selectedWelcomeItem, setSelectedWelcomeItem] = useState(null);

  // Close modal
  const handleCloseWelcome = () => setShowModalWelcome(false);

  // Confirm toggle and send POST request
  const confirmToggleWelcome = async () => {
    handleCloseWelcome();
    console.log('Confirmed toggle for:', selectedWelcomeItem);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-App-Setting/welcome-screen-active`,
        {
          id: selectedWelcomeItem?.id,
          active: selectedWelcomeItem?.active,
        },
        { headers: headers }
      );

      console.log('Toggle successful:', response.data);
      toast.success('Welcome screen status updated successfully!');
      fetchData();
    } catch (error) {
      console.error('Error toggling item:', error);
      toast.error('Failed to update welcome screen status.');
    }
  };


  // Handle toggle click
  const handleToggleWelcome = (e, item) => {
    if (item.active === 0) {
      setSelectedWelcomeItem({
        ...item,
        active: 1, // activating
      });
      setShowModalWelcome(true);
    } else {
      console.log('Item already active. No action triggered.');
    }
  };


  const handleModalOpenSplash = () => {
    setSelectedFile1(null);
    setSelectedFile2(null);
    setSelectedFile4(null);
    setSelectedFile5(null);
    setSelectedFile6(null);
    setSelectedFile7(null);
    setSelectedFile8(null);
    setFormDataError({});
  };

  const handleModalOpenWelcome = () => {
    setSelectedFile3(null);
    setSelectedFile9(null);
    setSelectedFile10(null);
    setSelectedFile11(null);
    setSelectedFile12(null);
    setSelectedFile13(null);
    setSelectedFile14(null);
    setFormDataError({});
    setValidationMessagename(null);
    setEditUser({ name: "" });
    setEditUser({ description: "" });
  };

  useEffect(() => {
    const modal = document.getElementById('splash');
    modal?.addEventListener('show.bs.modal', handleModalOpenSplash);

    return () => {
      modal?.removeEventListener('show.bs.modal', handleModalOpenSplash);
    };
  }, []);


  useEffect(() => {
    const modal = document.getElementById('welcome');
    modal?.addEventListener('show.bs.modal', handleModalOpenWelcome);

    return () => {
      modal?.removeEventListener('show.bs.modal', handleModalOpenWelcome);
    };
  }, []);

  return (
    <>
      <div
        className={`modal ${itemToDeletesplash !== null ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: itemToDeletesplash !== null ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModalsplash}
              ></button>
            </div>
            <div className="modal-body">
              {successMessagesplash ? (
                <div className="alert alert-success" role="alert">
                  {successMessagesplash}
                </div>
              ) : (
                <p>Are you sure you want to delete this Splash?</p>
              )}
            </div>
            <div className="modal-footer">
              {successMessagesplash ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeModalsplash}
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModalsplash}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeletedatasplash}
                  >
                    Yes
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal ${itemToDeletewelcome !== null ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: itemToDeletewelcome !== null ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModalwelcome}
              ></button>
            </div>
            <div className="modal-body">
              {successMessagewelcome ? (
                <div className="alert alert-success" role="alert">
                  {successMessagewelcome}
                </div>
              ) : (
                <p>Are you sure you want to delete this Welcome Screen?</p>
              )}
            </div>
            <div className="modal-footer">
              {successMessagewelcome ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeModalwelcome}
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModalwelcome}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeletedata}
                  >
                    Yes
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h4 className="admin-title mb-0 theme-text-color text-md-start">Mobile App Settings</h4>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  {/* <button onClick={handleUpdate} className="btn btn-primary">
                    Update Settings
                  </button> */}
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
            </div>

            <div className="row col-lg-12">

              <div className="card p-4">
                <ul className="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Splash Screen</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Welcome Screen</button>
                  </li>
                </ul>

                <div className="tab-content p-0" id="pills-tabContent">

                  <div
                    className="modal fade"
                    id="splash"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-scrollable">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="mb-0 theme-text-color text-md-start" id="staticBackdropLabel">
                            Add Splash Screen
                          </h4>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(IOS) </p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">
                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef1.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef1}
                                      id="fileInputRef1"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef1, setSelectedFile1, "welcome_images_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.welcome_images_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.welcome_images_url}`} classname='errorred  d-block' /></div>)}
                                </div>

                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile1 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile1)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(1)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(Andriod)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef2.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef2}
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef2, setSelectedFile2, "slash_image_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                      id="fileInputRef2"
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.slash_image_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.slash_image_url}`} classname='errorred  d-block' /></div>)}
                                </div>

                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile2 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile2)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(2)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(Android TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">


                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef4.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef4}
                                      id="fileInputRef4"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef4, setSelectedFile4, "android_tv_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.android_tv_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.android_tv_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>



                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile4 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile4)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(4)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(LG TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef5.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef5}
                                      id="fileInputRef5"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef5, setSelectedFile5, "lg_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.lg_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.lg_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>



                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile5 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            {selectedFile5.type.startsWith('image/') ? (
                                              <img
                                                src={URL.createObjectURL(selectedFile5)}
                                                alt="Uploaded"
                                                className="thumbnails-upload-images"
                                              />
                                            ) : selectedFile5.type.startsWith('video/') ? (
                                              <video
                                                src={URL.createObjectURL(selectedFile5)}
                                                controls
                                                className="thumbnails-upload-images"
                                              />
                                            ) : (
                                              <p>File type not supported for preview</p>
                                            )}
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(5)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(ROKU TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef6.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef6}
                                      id="fileInputRef6"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef6, setSelectedFile6, "RokuTV_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.RokuTV_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.RokuTV_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>



                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile6 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile6)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(6)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(SAMSUNG TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef7.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef7}
                                      id="fileInputRef7"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef7, setSelectedFile7, "samsung_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.samsung_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.samsung_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>



                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile7 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile7)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(7)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen (FIRE TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef8.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef8}
                                      id="fileInputRef8"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef8, setSelectedFile8, "fireTV_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.fireTV_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.fireTV_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>



                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile8 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile8)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(8)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">

                          <button
                            type="button"
                            className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                            onClick={savesplash}
                          >
                            Save Splash Screen
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div className="col-lg-12 row">
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                        {/* <h5>Splash Screen</h5> */}
                      </div>
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-end">
                        <button
                          className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                          data-bs-toggle="modal"
                          data-bs-target="#splash"
                        >
                          Add Splash
                        </button>
                      </div>
                    </div>
                    <div className=" text-start mt-2">
                      <div className="p-2 text-start iq-card-body">
                        <Table>
                          <thead>
                            <tr className="theme-text-color admin-input-title">
                              <th>IOS</th>
                              <th>ANDROID</th>
                              <th>ANDROID TV</th>
                              <th>LG TV</th>
                              <th>ROKU TV</th>
                              <th>SAMSUNG TV</th>
                              <th>FIRE TV</th>
                              <th>STATUS</th>
                              <th>ACTION</th>
                            </tr>
                          </thead>
                          <tbody>
                            {splash && splash.length > 0 ? (
                              splash.map((datas, key) => (
                                <tr key={key}>
                                  <td>
                                    <div>

                                      {loading ? (
                                        <Response_Loading_processing />
                                      ) : (
                                        <>
                                          {renderMedia(datas?.splash_image_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing />
                                      ) : (
                                        <>
                                          {renderMedia(datas?.andriod_splash_image_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing></Response_Loading_processing>
                                      ) : (
                                        <>
                                          {renderMedia(datas?.AndroidTv_splash_screen_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing></Response_Loading_processing>
                                      ) : (

                                        <>
                                          {renderMedia(datas?.LG_splash_screen_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing></Response_Loading_processing>
                                      ) : (
                                        <>
                                          {renderMedia(datas?.RokuTV_splash_screen_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing></Response_Loading_processing>
                                      ) : (
                                        <>
                                          {renderMedia(datas?.Samsung_splash_screen_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {loading ? (
                                        <Response_Loading_processing></Response_Loading_processing>
                                      ) : (
                                        <>
                                          {renderMedia(datas?.Firetv_splash_screen_url)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <AdminSwitch
                                        name="active"
                                        checked={datas?.active === 1}
                                        onChange={(e) => handleToggleSplash(e, datas)}
                                        id={datas?.active}
                                      />

                                      {/* Confirmation Modal */}
                                      {showModalSplash && (
                                        <div
                                          className="modal fade show"
                                          style={{ display: 'block' }}
                                          id="modalsplash"
                                          tabIndex="-1"
                                          aria-labelledby="modalsplashLabel"
                                          aria-hidden="false"
                                        >
                                          <div className="modal-dialog">
                                            <div className="modal-content">
                                              <div className="modal-header">
                                                <h5 className="modal-title" id="modalsplashLabel">Confirm Change</h5>
                                                <button type="button" className="btn-close" onClick={handleCloseSplash} aria-label="Close"></button>
                                              </div>
                                              <div className="modal-body">
                                                Are you sure you want to {selectedSplashItem?.active === 1 ? 'activate' : 'deactivate'} this item?
                                              </div>
                                              <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" onClick={handleCloseSplash}>No</button>
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={confirmToggleSplash}
                                                >
                                                  Yes
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {showModalSplash && <div className="modal-backdrop fade show"></div>}
                                    </div>
                                  </td>


                                  <td>
                                    <div className="editdropdown">
                                      <span className="editdropdown-button">
                                        <span>
                                          <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        </span>
                                      </span>
                                      <div className="editdropdown-menu">
                                        <Link
                                          to={"/mobileapp/splash/edit/" + datas?.id}
                                          className="edit"
                                        >
                                          <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                          <MessageBox text={`Edit`} classname='ms-2 theme-text-color'></MessageBox>
                                        </Link>
                                        <Link to="" className="delete">
                                          <span onClick={() => openModalsplash(datas?.id)}>
                                            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                            <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }} className="nodata-available">
                                  No Splash Screen available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>

                      </div>

                    </div>
                  </div>



                  <div
                    className="modal fade"
                    id="welcome"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-scrollable">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="mb-0 theme-text-color text-md-start" id="staticBackdropLabel">
                            Add Welcome Screen
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className=" text-start">
                            <p className="mandatorySimple theme-text-color mt-0 admin-input-title d-block position-relative">Title</p>
                            <div className="mt-2">
                              <AdminCustomInput
                                type="text"
                                name="name"
                                id="name1"
                                value={editUser?.name}
                                onChange={handleInput}
                                placeHolder="Title"
                                ref={(el) => (nameInputRef.current = el)}
                                error={validationMessagename}
                              />


                            </div>
                          </div>
                          <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Description</p>
                          <AdminCustomArea id="welcome-description" name="description" value={editUser?.description || ""} onChange={handleInput} placeHolder={"Enter description"} rows={5} />

                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Welcome Images</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">
                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef3.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef3}
                                      id="fileInputRef3"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef3, setSelectedFile3, "welcome_images_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.welcome_images_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.welcome_images_url}`} classname='errorred  d-block' /></div>)}
                                </div>
                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile3 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">

                                            <img
                                              src={URL?.createObjectURL(
                                                selectedFile3
                                              )}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(3)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className=" text-start mt-2">
                            <label className="m-0"></label>
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen (Andriod)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">
                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef9.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef9}
                                      id="fileInputRef9"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef9, setSelectedFile9, "slash_image_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.slash_image_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.slash_image_url}`} classname='errorred  d-block' /></div>)}
                                </div>
                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile9 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile9)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(9)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(Android TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">
                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef10.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef10}
                                      id="fileInputRef1"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef10, setSelectedFile10, "android_tv_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.android_tv_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.android_tv_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>
                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile10 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile10)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(10)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(LG TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef11.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef11}
                                      id="fileInputRef11"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef11, setSelectedFile11, "lg_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.lg_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.lg_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>
                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile11 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            {selectedFile11.type.startsWith('image/') ? (
                                              <img
                                                src={URL.createObjectURL(selectedFile11)}
                                                alt="Uploaded"
                                                className="thumbnails-upload-images"
                                              />
                                            ) : selectedFile11.type.startsWith('video/') ? (
                                              <video
                                                src={URL.createObjectURL(selectedFile11)}
                                                controls
                                                className="thumbnails-upload-images"
                                              />
                                            ) : (
                                              <p>File type not supported for preview</p>
                                            )}
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(11)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(ROKU TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">


                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef12.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef12}
                                      id="fileInputRef12"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef12, setSelectedFile12, "RokuTV_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.RokuTV_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.RokuTV_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>

                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile12 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile12)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(12)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(SAMSUNG TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">
                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef13.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef13}
                                      id="fileInputRef13"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef13, setSelectedFile13, "samsung_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.samsung_splash_screen_url && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.samsung_splash_screen_url}`} classname='errorred  d-block' /></div>)}
                                </div>


                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile13 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile13)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(13)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" text-start mt-2">
                            <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Splash Screen(FIRE TV)</p>
                            <div className="mt-2">
                              <div className="col-lg-12 row">

                                <div className=" col-sm-6 col-lg-6">
                                  <div className="imagedrop" onClick={() => fileInputRef14.current.click()}>
                                    <input
                                      type="file"
                                      ref={fileInputRef14}
                                      id="fileInputRef14"
                                      onChange={(event) =>
                                        handleFileChangesss(event, fileInputRef14, setSelectedFile14, "fireTV_splash_screen_url")
                                      }
                                      accept=".jpg,.jpeg,.png,.webp,.gif"
                                      style={{ display: "none" }}
                                    />
                                    <label><CameraRetroIcon /></label>
                                  </div>
                                  {formDataError?.fireTV_splash_screen_url && (
                                    <div className="errorred mt-1">{formDataError?.fireTV_splash_screen_url}</div>
                                  )}
                                </div>


                                <div className=" col-sm-6 col-lg-6">
                                  <div>
                                    {selectedFile14 && (
                                      <div className="imagedropcopy text-end">
                                        <div className="col-lg-12 row p-0 m-0">
                                          <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                            <img
                                              src={URL?.createObjectURL(selectedFile14)}
                                              alt="Uploaded"
                                              className="thumbnails-upload-images"
                                            />
                                          </div>
                                          <div
                                            className="col-sm-2 col-lg-2 p-0 m-0"
                                            style={{ alignSelf: "center" }}
                                          >
                                            <button
                                              onClick={() => handleDelete(14)}
                                              type="button"
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                            onClick={savewelcome}
                          >
                            Save Welcome Screen
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div className="">
                      <div className="col-lg-12 row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                          {/* <h5>Welcome Screen</h5> */}
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-end">
                          <button
                            className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                            data-bs-toggle="modal"
                            data-bs-target="#welcome"
                          >
                            Add Welcome Screen
                          </button>
                        </div>
                      </div>

                      <div className=" text-start mt-2">
                        <div className="p-2 text-start iq-card-body">
                          <Table>
                            <thead>
                              <tr className="theme-text-color admin-input-title">
                                <th>NAME</th>
                                <th>WELCOME SCREEN</th>
                                <th>ANDROID WELCOME SCREEN</th>
                                <th>ANDROID TV</th>
                                <th>LG TV</th>
                                <th>ROKU TV</th>
                                <th>SAMSUNG TV</th>
                                <th>FIRE TV</th>
                                <th>STATUS</th>
                                <th>ACTION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data && data.length > 0 ? (
                                data.map((datas, key) => (
                                  <tr key={key}>
                                    <td>
                                      <div>{datas?.name}</div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (
                                          <>
                                            {renderMedia(datas?.welcome_images_url)}
                                          </>)}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (
                                          <>
                                            {renderMedia(datas?.andriod_Welcome_Screen_url)}
                                          </>

                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (

                                          <>
                                            {renderMedia(datas?.AndroidTv_Welcome_Screen_url)}
                                          </>

                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (

                                          <>
                                            {renderMedia(datas?.LG_Welcome_Screen_url)}
                                          </>



                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (


                                          <>
                                            {renderMedia(datas?.RokuTV_Welcome_Screen_url)}
                                          </>


                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (

                                          <>
                                            {renderMedia(datas?.Samsung_Welcome_Screen_url)}
                                          </>


                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {loading ? (
                                          <Response_Loading_processing></Response_Loading_processing>
                                        ) : (

                                          <>
                                            {renderMedia(datas?.Firetv_Welcome_Screen_url)}
                                          </>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <td>
                                          <div>
                                            <AdminSwitch
                                              name="active"
                                              checked={datas?.active === 1}
                                              onChange={(e) => handleToggleWelcome(e, datas)}
                                              id={datas?.active}
                                            />

                                            {/* Confirmation Modal */}
                                            {showModalWelcome && (
                                              <div
                                                className="modal fade show"
                                                style={{ display: 'block' }}
                                                id="modalWelcome"
                                                tabIndex="-1"
                                                aria-labelledby="modalWelcomeLabel"
                                                aria-hidden="false"
                                              >
                                                <div className="modal-dialog">
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5 className="modal-title" id="modalWelcomeLabel">Confirm Change</h5>
                                                      <button type="button" className="btn-close" onClick={handleCloseWelcome} aria-label="Close"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                      Are you sure you want to {selectedWelcomeItem?.active === 1 ? 'activate' : 'deactivate'} this item?
                                                    </div>
                                                    <div className="modal-footer">
                                                      <button type="button" className="btn btn-secondary" onClick={handleCloseWelcome}>No</button>
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={confirmToggleWelcome}
                                                      >
                                                        Yes
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                            {showModalWelcome && <div className="modal-backdrop fade show"></div>}
                                          </div>
                                        </td>
                                      </div>
                                    </td>


                                    <td>
                                      <div className="editdropdown">
                                        <span className="editdropdown-button">
                                          <span>
                                            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                          </span>
                                        </span>
                                        <div className="editdropdown-menu">
                                          <Link
                                            to={"/mobileapp/edit/" + datas?.id}
                                            className="edit"
                                          >
                                            <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                            <MessageBox text={`Edit`} classname='ms-2 theme-text-color'></MessageBox>
                                          </Link>
                                          <Link to="" className="delete">
                                            <span
                                              onClick={() =>
                                                openModalwelcome(datas?.id)
                                              }
                                            >
                                              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                              <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
                                            </span>
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="8" style={{ textAlign: 'center' }} className="nodata-available">
                                    No Welcome Screen available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>


    </>
  );
}

export default MobileSettings;
